import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UserTimePipe } from "app/components/shared/UserTimePipe";
import { LoadingService } from "app/services/loading-service/loading.service";
import { ConfirmationService, SelectItem } from "primeng/api";
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from "app/services/excel-service/excel.service";
import { SinisterTypeService } from '../../../../../services/table-management/sinisterType.service';
import { SinisterTypeFormComponent } from '../sinister-type-form/sinister-type-form.component';

@Component({
  selector: 'app-sinister-type-list',
  templateUrl: './sinister-type-list.component.html',
  styleUrls: ['./sinister-type-list.component.css'],
  providers: [SinisterTypeService, ConfirmationService, UserTimePipe, ExcelService],
  
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SinisterTypeListComponent extends EntityListComponent<Rest.InvSinisterType>
  implements OnInit {

  @ViewChild(SinisterTypeFormComponent, { static: true })
    sinisterTypeForm: SinisterTypeFormComponent;
  
    title: string = this.translateService.instant('tableManagement.sinister.sinisterType');
    disableSave: boolean;
    EnabledFilter: SelectItem[];
    isCreateGranted: boolean;
    isDisabledGranted: boolean;
  
    constructor(
      private sinisterTypeService: SinisterTypeService,
      protected confirmationService: ConfirmationService,
      public notificationsService: NotificationsService,
      protected i18n: I18nService,
      authenticationService: AuthenticationService,
      protected loadingService: LoadingService,
      protected userTime: UserTimePipe,
      protected excelService: ExcelService,
      protected translateService: TranslateService,
    ) {
      super(
        sinisterTypeService,
        confirmationService,
        notificationsService,
        i18n,
        authenticationService,
        loadingService,
        userTime,
        excelService
      );
      this.sinisterTypeService = sinisterTypeService;
    }
  
    ngOnInit() {
      super.ngOnInit();
      this.form = this.sinisterTypeForm;
      this.setPermissions();
    }

    setPermissions() {
		    const user = this.authenticationService.user;
		    this.isCreateGranted = this.authenticationService.isRoleGranted('INV_SINISTER_TYPE_CREATE', user);
		    this.isDisabledGranted = this.authenticationService.isRoleGranted('INV_SINISTER_TYPE_DISABLE', user);

	  }

    beforeLoad() {
      
      this.paginationRequest.sortAsc= false;
      if (this.paginationRequest.filters.hasOwnProperty("disabled")) {
        this.paginationRequest.filters["disabled"] = this.paginationRequest.filters["disabled"][0].toString() == "true" ? ["false"] : ["true"];
      }
    }
  
    afterLoad() {
      
    }
    excelColumns = {};
    exportExcel() {
      this.setExcelColumns();
      let fileNameTitle = this.translateService.instant('tableManagement.sinister.sinisterType');
      super.exportExcelWithColumns(fileNameTitle, this.excelColumns);
    }
    setExcelColumns() {
      const name = (entity: any) => entity.name ?? ''
      const createDate = (entity: any) => entity.createDate ?? ''
      const updateDate = (entity: any) => entity.updateDate ?? ''
      const disabled = (entity: any) => !entity.disabled
      this.excelColumns = {
        [this.translateService.instant('general.name')]: { bindField: name },
        [this.translateService.instant('general.active')]: { bindField: disabled },
      }
    }

}

